var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconX = function SvgIconX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E3EFFC",
    d: "M12.6.592h2.454l-5.36 6.132L16 15.068h-4.937l-3.867-5.06-4.425 5.06H.316l5.733-6.559L0 .592h5.063l3.495 4.626zm-.86 13.006h1.36L4.323 1.984H2.865z"
  })));
};
export default SvgIconX;